import ajax from '@/resources/myApi';
import vm from '@/main';
import { listDto, dataItemDto } from './dto';

export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
};

const service = {
  getAll,
  getLocations,
  getCompanyRoles,
  getCompanyAttributes,
  getCompanyStatusValues,
  getParentCompanies,
  getCompanyChannels,
  getSubmittedBy,
  getCompanies,
  getById,
  create,
  update,
  patch,
  deleteIds,
  verifyCompany,
  saveCompanyRecord,
  setPrimaryLocation,
  saveCompanyLocationRecord,
  deleteLocation,
  getCasesDetails,
  getNetworksDetails,
  getCorporateType,
  getCorporateState,
  saveCompanyNotes,
  saveCorporateDetails
};

async function saveCompanyRecord(spObj) {
  try {
    spObj.vwDto.dateCreated = '';
    spObj.vwDto.dateModified = '';
    spObj.vwDto.isDemo = false;
    spObj.vwDto.isVerified = false;
    const { data } = await ajax.post('api/company/quick', {
      name: 'company',
      body: spObj
    });

    vm.$snotify.success('Company has been saved', 'Company');

    return data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

async function getLocations(
  companyId,
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
  searchValue
) {
  try {

    const params = {
      companyId,
      pageNumber,
      pageSize,
      sortOrder,
      sortBy,
      searchValue
    };

    const { data } = await ajax.get(`api/companyLocation/forCompany`, {
      name: 'locations',
      params
    });
    return data;
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('company not found');
      vm.$router.push({ name: 'company' });
    }
    return {};
  }
}

async function getAll() {
  try {
    const { data } = await ajax.get('api/company/', {
      name: 'company'
    });
    return new listDto(data);
  } catch { }
}

async function getCompanyRoles() {
  try {
    const { data } = await ajax.get('api/CompanyRole/', {
      name: 'company roles'
    });
    return data;
  } catch { }
}

async function getCompanyAttributes() {
  try {
    const { data } = await ajax.get('api/Attribute/All', {
      name: 'company attributes'
    });
    return data;
  } catch { }
}

async function getParentCompanies() {
  try {
    const { data } = await ajax.get('api/CompaniesLookupView', {
      name: 'parent companies'
    });
    return data;
  } catch { }
}

async function getCompanyChannels() {
  try {
    const { data } = await ajax.get('api/BusinessChannel', {
      name: 'company channels'
    });
    return data;
  } catch { }
}

async function getCompanyStatusValues() {
  try {
    const { data } = await ajax.get('api/CompanyStatusLookupView', {
      name: 'company status values'
    });
    return data.filter(status => status.val === "Active" || status.val === "Inactive");
  } catch { }
}

async function getSubmittedBy() {
  try {
    const { data } = await ajax.get('api/SubmittedByLookupView', {
      name: 'submitted by'
    });
    return data;
  } catch { }
}

async function getCompanies(
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
  filters
) {
  const params = {
    pageNumber,
    pageSize,
    sortBy,
    sortOrder,
    filters,
  };
  //console.log(params.filters);
  try {
    const { data } = await ajax.get('api/company/', {
      name: 'companies',
      params
    });

    return data;

    //return new listDto(data);
  } catch { }
}

async function getById(id) {
  try {
    const { data } = await ajax.get(`api/company/${id}`, {
      name: 'company edit'
    });
    return data; //new dataItemDto(data);
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('company not found');
      vm.$router.push({ name: 'company' });
    }

    return {};
  }
}

async function create(dto) {
  try {
    const { data } = await ajax.post('api/company', {
      name: 'company',
      body: dto
    });

    vm.$snotify.success('Company has been saved', 'Company');

    return data.id;
  } catch (error) {
    throw error;
  }
}

async function update(dto) {
  try {
    await ajax.put(`api/company/${dto.id}`, {
      name: 'company',
      body: dto
    });
    vm.$snotify.success('company changes saved', 'company');
  } catch { }
}

async function patch(id, data) {
  try {
    await ajax.patch(`api/patchaccount/${id}`, {
      name: 'company',
      body: data
    });
  } catch { }
}

async function deleteIds(ids) {
  let param = '?';
  param += ids.map(q => `companyIds=${q}`).join('&');
  try {
    await ajax.delete(`api/company/DeleteMulti/${param}`, {
      name: 'company'
    });
  } catch { }
}

async function verifyCompany(id) {
  try {
    const { data } = await ajax.patch(`api/company/${id}`, {
      name: 'company',
      body: [
        {
          'value': true,
          'path': '/isVerified',
          'op': 'replace',
        }
      ],
    });
    return data;
  } catch { }
}

async function setPrimaryLocation(locationIds) {
  try {
    // Patching two Ids as one primary location only. 
    // First index is for the Old Primary Location, Second Index is for the New Primary Location
    if (locationIds[0] != 0) {
      await ajax.patch(`api/companylocation/${locationIds[0]}`, {
        name: 'companylocation old primary',
        body: [
          {
            'value': false,
            'path': '/isPrimary',
            'op': 'replace',
          }
        ],
      });
    }

    await ajax.patch(`api/companylocation/${locationIds[1]}`, {
      name: 'companylocation new primary',
      body: [
        {
          'value': true,
          'path': '/isPrimary',
          'op': 'replace',
        }
      ],
    });
  } catch { }
}

async function saveCompanyLocationRecord(spObj, isUpdateRecord) {
  try {
    const params = {
      name: 'companylocation save',
      body: spObj
    };

    const { data } = (isUpdateRecord)
      ? await ajax.put(`api/companylocation/${spObj.id}`, params)
      : await ajax.post('api/companylocation', params);

    vm.$snotify.success('Company Location has been saved', 'Company Location');

    return data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

async function deleteLocation(id) {
  try {
    const { data } = await ajax.delete(`api/companylocation/${id}`, {
      name: 'company location delete'
    });

    vm.$snotify.success('Company Location has been deleted', 'Company Location');
    console.log(data);
    return data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

async function getCasesDetails(
  companyId,
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
  filters
) {
  try {
    const params = {
      companyId,
      pageNumber,
      pageSize,
      sortOrder,
      sortBy,
      filters
    };
    const { data } = await ajax.get(`api/companyCaseView/forCompany`, {
      name: 'cases',
      params
    });
    return data;
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('company not found');
    }
    return {};
  }
}

async function getNetworksDetails(id) {
  try {
    const { data } = await ajax.get(`${id}/networks`);
    return data;
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('company not found');
    }
    return {};
  }
}

async function getCorporateType() {
  try {
    const { data } = await ajax.get('api/CompanyBusinessEntityLookupView', {
      name: 'corporate type'
    });
    return data;
  } catch { }
}

async function getCorporateState() {
  try {
    const { data } = await ajax.get('api/State', {
      name: 'corporate state'
    });
    return data;
  } catch { }
}

async function saveCompanyNotes(notesObj) {
  try {
    const { data } = await ajax.post('api/Company/saveNotes', {
      name: 'company',
      body: notesObj
    });
    vm.$snotify.success('Notes has been saved', 'Company');
    return true;
  } catch (error) {
    throw error;
  }
}

async function saveCorporateDetails(corporateObj) {
  try {
    const { data } = await ajax.post('api/Company/saveCorporateDetails', {
      name: 'company',
      body: corporateObj
    });
    vm.$snotify.success('Corporate Details has been saved', 'Company');
    return true;
  } catch (error) {
    throw error;
  }
}

export default service;
